import { Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StorageService } from './storage.service';
import * as UAParser from 'ua-parser-js';
declare global {  interface Window {_paq: any; } }

@Injectable({
  providedIn: 'root'
})
export class InhouseAnalyticsService {
  previousUrl: any;
  currentUrl: any;

  constructor(private router: Router, private storageService: StorageService, private ngZone: NgZone) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      }
    });
  }

  trackUserActions(eventObj) {
    this.ngZone.runOutsideAngular(() => {
      const region = this.storageService.getLocalStore('region');
      const locale = this.storageService.getLocalStore('locale');
      const countryCode = this.storageService.getLocalStore('country_code');
      const userId = this.storageService.getLocalStore('u_id') || this.storageService.getLocalStore('g_id');
      const deviceId = this.storageService.getLocalStore('d_id');
      const currentDate = new Date();
      const epochTime= Math.floor(currentDate.getTime() / 1000);
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const userType = this.storageService.getLocalStore('user_type') || 0;
      const profileId = this.storageService.getSessionStore('profileId');

      const  sessionId = this.getInhouseAnalyticsSessionId();

      const actionObj = {
        event_type:	eventObj?.event_type || '',
        event_name: eventObj?.event_name || '',
        event_id: this.generateGUID(),
        session_id: sessionId,
        device_type: 'web' ,
        country: countryCode,
        region: region,
        locale: locale,
        page_location: window.location.href,
        page_referrer: this.getScreenName(this.previousUrl),
        page_title: this.getScreenName(this.currentUrl),
        user_device_info: this.getBrowserInfo(),
        user_agent: navigator.userAgent,
        source: eventObj?.source || '',
        operator: eventObj?.operator || '',
        medium: eventObj?.medium || '',
        campaign: eventObj?.campaign || '',
        content_type: eventObj?.content_type || '',
        content_id: eventObj?.content_id || '',
        profile_id: profileId,
        user_id: userId,
        device_id: deviceId,
        guest_user: userId ? 0 : 1,
        currency: eventObj?.currency || '',
        value: eventObj?.value || '',
        payment_type: eventObj?.payment_type || '',
        discount_code: eventObj?.discount_code || '',
        subscription_status: eventObj?.subscription_status || '',
        paid_user: userType,
        subscription_plan: eventObj?.subscription_plan || '',
        event_status: eventObj?.event_status || '',
        event_description: eventObj?.event_description || '',
        extra_info: eventObj?.extra_info || '',
        created_at: epochTime,
        timezone: timezone
      }
      try {
        var _paq = window._paq = window._paq || [];
        _paq.push(['trackEvent', actionObj.event_type, actionObj.event_name, JSON.stringify(actionObj)]);
      } catch (err) {
          console.log(err);
      }
    });
  
  }

  getInhouseAnalyticsSessionId() {
    let sessionId = this.storageService.getSessionStore('inhouse_analytics_session_id');
    if (sessionId) {
      return sessionId;
    } else {
      const sessionId = this.generateGUID();
      this.storageService.setSessionStore('inhouse_analytics_session_id', sessionId);
      return sessionId;
    }
  }

  getBrowserInfo() {
    let value = new UAParser();
    let parser = value.getResult();
    let device = "Browser (Desktop)";
    if(window.innerWidth <= 768) device = "Browser (Mobile)"
    const browserInfo =  {"manufacturer": device, "model": parser.browser.name,"version": parser.browser.version,
    "osName": parser.os.name, "osVersion": parser.os.version ,"displayWidth":  window.innerWidth, "displayHeight": window.innerHeight};
    return browserInfo;
  }

  getScreenName(routerUrl) {
    let screenName = '';
    if (routerUrl) {
      switch (true) {
        case routerUrl.includes('/home'):
          screenName = 'Home Page';
          break;
        case routerUrl.includes('/voucher'):
          screenName = 'Voucher Page';
          break;
        case routerUrl.includes('/category'):
          screenName = 'Category Page';
          break;
        case routerUrl.includes('/list') || routerUrl.includes('/collection'):
          screenName = 'Collection Page';
          break;
        case routerUrl.includes('/v') || routerUrl.includes('/video') || routerUrl.includes('/series') || routerUrl.includes('/vs'):
          screenName = 'Content Detail Page';
          break;
        case routerUrl.includes('/auth/signin'):
          screenName = 'Login Screen';
          break;
        case routerUrl.includes('/auth/signup'):
          screenName = 'Signup Screen';
          break;
        case routerUrl.includes('/auth/plan'):
          screenName = 'Plans Page';
          break;
        case routerUrl.includes('/account/settings'):
          screenName = 'Account Page';
          break;
        case routerUrl.includes('index/operators'):
          screenName = 'Operators List page';
        default:
          screenName = `${routerUrl.split('/')[0]} Page`;
      }

    }
    return screenName;
  }

  generateGUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
  }

}
